module.exports = __webpack_public_path__ + "static/media/carousel-1.7def4949.jpg";